<div class="form-field__label form-field__label--external">
  {{ field?.label | translateInline }}
</div>

<fmnts-compliment-list
  multiple
  class="compliments"
  [(ngModel)]="value"
  [disabled]="isDisabled"
>
  @for (c of compliments; track c.value) {
    <fmnts-compliment-toggle
      [label]="c.label | translateInline"
      [image]="c.image"
      [value]="c.value"
      labelPosition="bottom"
    ></fmnts-compliment-toggle>
  }
</fmnts-compliment-list>
